import { Element } from "@craftjs/core";
import CardCarousel from "components/general/CardCarousel";
import Container from "components/general/Container";
import Section from "components/general/Section";
import ItemCard from "components/item/ItemCard";
import ArticleCard from "components/general/Card/ArticleCard";
import { Box } from "components/ui";
import React from "react";
import { useGetArticleQuery, useGetCategoryByCategorySlugAndSubCategorySlugQuery, useGetRecommendedQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { PageButton } from "./PageButton";
import { PageContainer } from "./PageContainer";
import { PageText } from "./PageText";

export const CardListingDefaultProps = {
	type: "product",
};

export const PageCardListingTitle = (props: any) => {
	if (!props.children) return null;
	let isMobile = useIsMobile();
	let firstChild = props.children.props.children[0];
	let secondChild = props.children.props.children[1];
	if (isMobile) {
		return (
			<Box flex={1} flexDirection="row" my={32} justifyContent="space-between" paddingHorizontal={16} alignItems="center">
				{firstChild}
			</Box>
		);
	}
	return (
		<Box flexDirection="row" my={32} justifyContent="space-between" alignItems="center">
			{props.children}
		</Box>
	);
};

export const PageCardListing = ({ type, ...props }: any) => {
	let slug = "chemicals";
	let isMobile = useIsMobile();
	const [mobileElement, setMobileElement] = React.useState<any>(null);

	// Get articles data
	const {
		data: articlesData,
		isLoading: pageIsLoading,
		isFetching: pageIsFetching,
	} = useGetArticleQuery({
		pageSize: 24,
		pageNumber: 1,
	});

	// Get recommended products data
	const { data: recommendedProductCollection } = useGetRecommendedQuery();

	// Determine which data to use based on type
	let dataListing = null;
	let itemsToRender: any[] = [];

	if (type === "recent-articles") {
		// Get the 3 most recent articles
		dataListing = articlesData;
		itemsToRender = articlesData?.list ? articlesData.list.slice(0, 3) : [];
	} else if (type === "recommended-products") {
		// Use recommended products
		dataListing = recommendedProductCollection;
		itemsToRender = recommendedProductCollection ? recommendedProductCollection.slice(0, 5) : [];
	}

	// const {
	// 	data: category,
	// 	isLoading,
	// 	isFetching,
	// 	isError,
	// 	error,
	// 	currentData,
	// }: { data?: any; isLoading: boolean; isFetching: boolean; isError: boolean; error?: any; currentData?: any } = useGetCategoryByCategorySlugAndSubCategorySlugQuery(
	// 	{
	// 		categorySlug: "chemicals",
	// 		subCategorySlug: "deodorisers",
	// 	},
	// 	{ skip: !slug },
	// );
	// if (!category) return null;

	if (isMobile) {
		return (
			<PageContainer style={{ background: "#fafafa" }} padding={0}>
				<Container>
					<Box style={{ padding: 0 }} gap={16} {...props}>
						<Element setMobileElement={setMobileElement} test="true" id="listing-title" className="card-list-title-container" is={PageCardListingTitle} data-cy="listing-title">
							<PageText sx={{ marginBottom: 0 }} text="Listing Title" fontSize={16} fontWeight="bold" />
							<PageButton size="small" text="View All" variant="secondary" data-cy="card-bottom-button" />
						</Element>
						<Box>
							<CardCarousel hideArrows={itemsToRender.length <= 3} infinite={true} showDots={itemsToRender.length > 3}>
								{itemsToRender.map((item: any, key: number) => {
									if (type === "recent-articles") {
										return <ArticleCard key={key} data={item} />;
									} else {
										return <ItemCard key={key} item={item} />;
									}
								})}
							</CardCarousel>
						</Box>
						{mobileElement}
					</Box>
				</Container>
			</PageContainer>
		);
	}
	return (
		<Section paddingVertical={0} paddingHorizontal={0}>
			<Container>
				<Box {...props}>
					<Element id="listing-title" className="card-list-title-container" is={PageCardListingTitle} data-cy="listing-title">
						<PageText sx={{ marginBottom: 0 }} text="Listing Title" fontSize={16} fontWeight="bold" />
						<PageButton size="small" text="View All" variant="secondary" data-cy="card-bottom-button" />
					</Element>
					<Box>
						<CardCarousel hideArrows={itemsToRender.length <= 3} infinite={true} showDots={itemsToRender.length > 3}>
							{itemsToRender.map((item: any, key: number) => {
								if (type === "recent-articles") {
									return <ArticleCard key={key} data={item} />;
								} else {
									return <ItemCard key={key} item={item} />;
								}
							})}
						</CardCarousel>
					</Box>
				</Box>
			</Container>
		</Section>
	);
};
